module.exports = __webpack_public_path__ + "img/img14.ccbb960e.svg";